const rows = [
  { feature: "Distance from Johnson City", fpc: "Zero — we come to you", agency: "100 miles to Knoxville Passport Agency" },
  { feature: "Appointment Required", fpc: "No — we handle everything", agency: "Yes — call NPIC, limited slots" },
  { feature: "Document Review", fpc: "Yes — we catch errors before submission", agency: "No — rejected if wrong" },
  { feature: "Processing Speed", fpc: "2–9 business days guaranteed", agency: "Same-day if approved (rare)" },
  { feature: "Agent Support", fpc: "Dedicated agent for your case", agency: "Government clerk only" },
  { feature: "Status Updates", fpc: "Daily email and phone updates", agency: "No tracking provided" },
  { feature: "ETSU Study Abroad Support", fpc: "Yes — specialized student processing", agency: "No special provisions" },
  { feature: "Guaranteed Timing", fpc: "Yes — contractual turnaround", agency: "No — subject to availability" },
];

export default function JohnsonCityComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Why Choose Us</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Going It Alone
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Johnson City residents who try to visit the Knoxville Passport Agency face a 100-mile drive, no appointment guarantee, and an entire lost workday. Here's the real comparison.
          </p>
        </div>

        <div className="bg-white rounded-xl overflow-hidden border border-gray-200">
          <div className="grid grid-cols-3 bg-[#1A365D] text-white text-sm font-semibold">
            <div className="p-5">Feature</div>
            <div className="p-5 text-center">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-shield-check-line text-[#F6C344]"></i>
                Fast Passport Center
              </span>
            </div>
            <div className="p-5 text-center text-white/60">DIY / Post Office</div>
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-3 text-sm ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}>
              <div className="p-5 font-medium text-[#1A365D]">{row.feature}</div>
              <div className="p-5 text-center">
                <div className="flex items-center justify-center gap-1.5 text-green-700">
                  <i className="ri-checkbox-circle-line"></i>
                  <span>{row.fpc}</span>
                </div>
              </div>
              <div className="p-5 text-center text-gray-400">
                <div className="flex items-center justify-center gap-1.5">
                  <i className="ri-close-circle-line text-gray-300"></i>
                  <span className="text-xs">{row.agency}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-passport-line"></i>
            Get Started — Skip the Drive
          </a>
        </div>
      </div>
    </section>
  );
}